import script from "./MarkupSegment.vue?vue&type=script&setup=true&lang=js"
export * from "./MarkupSegment.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__